<template>
    <div class="w-100">
        <s-crud title="Pagos de Productores" :filter="filter" searchInput height="68vh" :config="config" :add="false"
            :edit="false" :remove="false" @rowSelected="rowSelected($event)" ref="crudproducerpayment">
            <template v-slot:options>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" text color="white" @click="exportExcel" small :loading="loadingExportMain"
                            class="text-none font-weight-bold">
                            <v-icon>mdi-file-excel</v-icon>
                        </v-btn>
                    </template>
                    <span>Exportar pagos de productores</span>
                </v-tooltip>
            </template>

            <template v-slot:filter>
                <v-container fluid class="">
                    <v-row dense align="center" class="mx-n1">
                        <v-col cols="12" sm="6" md="4" lg="3" class="">
                            <s-date label="Fecha Contabilización Hasta:" v-model="filter.TaxDate" outlined dense
                                hide-details class="premium-input-compact" />
                        </v-col>
                        <v-col cols="12" sm="6" md="4" lg="3" class="">
                            <s-select label="Semana:" v-model="filter.Week" :items="weeksList" item-value="Week"
                                item-text="YearWeek" class="premium-input-compact" :clearable="true"></s-select>
                        </v-col>
                    </v-row>
                </v-container>
            </template>

            <template v-slot:[`item.CardCode`]="{ item }">
                <div class="d-flex flex-column py-1 align-start">
                    <span class="card-code-badge mb-1">
                        {{ item.CardCode }}
                    </span>
                    <span class="text-subtitle-2 font-weight-medium grey--text text--darken-4">
                        {{ item.CardName }}
                    </span>
                </div>
            </template>

            <template v-slot:[`item.AmountMS`]="{ item }">
                <span class="font-weight-bold grey--text text--darken-3">
                    {{ formatNumber(item.AmountMS) }}
                </span>
            </template>

            <template v-slot:[`item.AmountML`]="{ item }">
                <span class="font-weight-bold grey--text text--darken-3">
                    {{ formatNumber(item.AmountML) }}
                </span>
            </template>

            <template v-slot:[`item.AmountME`]="{ item }">
                <span class="font-weight-bold grey--text text--darken-3">
                    {{ formatCurrency(item.AmountME, 'US$') }}
                </span>
            </template>

            <template v-slot:[`item.Currency`]="{ item }">
                <span class="font-weight-medium grey--text text--darken-3">
                    {{ item.Currency }}
                </span>
                <v-chip v-if="item.Currency == 'US$'" x-small color="primary" class="font-weight-bold rounded pa-1" dark
                    style="font-size: 0.725rem;">
                    {{ item.DocRate }}
                </v-chip>
            </template>

            <template v-slot:[`item.AccountingDate`]="{ item }">
                <span>{{ $fun.formatDateView(item.AccountingDate) }}</span>
            </template>

            <template v-slot:[`item.IssueDate`]="{ item }">
                <span>{{ $fun.formatDateView(item.IssueDate) }}</span>
            </template>

            <template v-slot:[`item.DueDate`]="{ item }">
                <span>{{ $fun.formatDateView(item.DueDate) }}</span>
            </template>

            <template v-slot:[`item.BankName`]="{ item }">
                <p class="text-subtitle-2 font-weight-medium grey--text text--darken-2 text-center pa-0 ma-0">
                    {{ item.BankName }} <br>
                    {{ item.AccountNumber }}
                </p>
            </template>

            <template v-slot:[`item.Active`]="{ item }">
                <v-chip outlined small color="primary" class="font-weight-bold rounded-lg pa-2 text-uppercase" dark
                    style="font-size: 0.725rem;">
                    {{ item.Active }}
                </v-chip>
            </template>

            <template v-slot:[`item.DocStatus`]="{ item }">
                <v-chip outlined small :color="item.DocStatus == 'C' ? 'error' : 'success'"
                    class="font-weight-bold rounded-lg pa-2" dark style="font-size: 0.725rem;">
                    {{ item.DocStatus == 'C' ? 'CERRADO' : 'ABIERTO' }}
                </v-chip>
            </template>

            <template v-slot:[`item.Options`]="{ item }">
                <div class="d-flex justify-center align-center">
                    <v-btn small depressed color="primary" class="text-none font-weight-medium rounded-lg"
                        @click.stop="openDebtAdjustmentModal(item)">
                        Ajustar
                    </v-btn>
                </div>
            </template>
        </s-crud>

        <AlertSunshine :dialog="loadingCalculate" text="CARGANDO" />

        <v-dialog v-model="debtAdjustmentModalVisible" max-width="1300px" scrollable>
            <v-card class="rounded-xl overflow-hidden">
                <v-card-title class="primary d-flex align-center px-4 py-2 white--text">
                    <div>
                        <span class="text-h6 font-weight-bold d-block white--text" style="line-height: 1.2;">
                            Propuesta de Ajuste y Compensación de Deudas
                        </span>
                        <span class="text-caption mt-1 d-inline-block white--text" style="opacity: 0.9;"
                            v-if="selectedPayment">
                            Proveedor:
                            <span class="font-weight-bold white--text">
                                {{ selectedPayment.CardCode }} - {{ selectedPayment.CardName }}
                            </span>
                        </span>
                    </div>
                    <v-spacer></v-spacer>
                    <v-btn icon small @click="debtAdjustmentModalVisible = false" dark
                        style="background-color: rgba(255, 255, 255, 0.15) !important;">
                        <v-icon size="18">mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text class="pa-4" style="background-color: #f8fafc;" v-if="selectedPayment">
                    <!-- Top grid: Current Payment vs Total Debt vs Netted Result -->
                    <v-row dense class="mb-4">
                        <!-- Card 1: Pago Original -->
                        <v-col cols="12" md="4">
                            <div class="summary-box-premium original-payment">
                                <div class="box-icon-label">
                                    <span class="box-title">PAGO PROGRAMADO</span>
                                    <v-icon color="blue darken-3">mdi-cash-register</v-icon>
                                </div>
                                <div class="box-amounts">
                                    <div class="main-amount font-mono">

                                        {{ formatCurrency(selectedPayment.Currency == 'S/' ? selectedPayment.AmountML :
                                            selectedPayment.AmountMS,
                                            selectedPayment.Currency
                                        ) }}
                                    </div>
                                    <div class="sub-amounts font-mono text-caption grey--text text--darken-2">
                                        Equivalente:
                                        {{
                                            formatCurrency(
                                                selectedPayment.Currency == 'S/' ? selectedPayment.AmountMS :
                                                    selectedPayment.AmountML,
                                                selectedPayment.Currency == 'S/' ? 'US$' : 'S/'
                                            )
                                        }}
                                        | {{ selectedPayment.DocRate }}
                                    </div>
                                </div>
                                <div class="box-footer pt-2 border-t text-caption text-truncate">
                                    SAP Nº:
                                    <span class="font-weight-bold">{{ selectedPayment.DocNum }}</span>
                                    | Tipo: {{ selectedPayment.DocumentType }}
                                </div>
                            </div>
                        </v-col>

                        <!-- Card 2: Deudas Acumuladas -->
                        <v-col cols="12" md="4">
                            <div class="summary-box-premium total-debt">
                                <div class="box-icon-label">
                                    <span class="box-title">DEUDAS PENDIENTES</span>
                                    <v-icon color="red darken-3">mdi-alert-circle-outline</v-icon>
                                </div>
                                <div class="box-amounts">
                                    <div class="main-amount red--text text--darken-3 font-mono">
                                        {{ formatCurrency(debtTotals.ml, 'S/') }}
                                    </div>
                                    <div class="sub-amounts font-mono text-caption grey--text text--darken-2">
                                        En USD: {{ formatCurrency(debtTotals.me, 'US$') }}
                                    </div>
                                </div>
                                <div class="box-footer pt-2 border-t d-flex align-center justify-space-between">
                                    <span class="text-caption">Total Documentos: <b>{{ debtDetails.length }}</b></span>
                                    <v-chip x-small :color="debtTotals.ml > 0 ? 'error' : 'success'"
                                        class="font-weight-bold text-uppercase">
                                        {{ debtTotals.ml > 0 ? 'Con deudas' : 'Sin deudas' }}
                                    </v-chip>
                                </div>
                            </div>
                        </v-col>

                        <!-- Card 3: Neto a Pagar -->
                        <!-- <v-col cols="12" md="4">
                            <div class="summary-box-premium net-payment">
                                <div class="box-icon-label">
                                    <span class="box-title">NETO PROPUESTO</span>
                                    <v-icon color="green darken-3">mdi-scale-balance</v-icon>
                                </div>
                                <div class="box-amounts mt-2">
                                    <div class="main-amount green--text text--darken-3 font-mono">
                                        {{ formatCurrency(nettedTotals.ml, 'S/') }}
                                    </div>
                                    <div class="sub-amounts font-mono text-caption grey--text text--darken-2">
                                        En USD: {{ formatCurrency(nettedTotals.me, 'US$') }}
                                    </div>
                                </div>
                                <div class="box-footer mt-2 pt-2 border-t d-flex align-center justify-space-between">
                                    <span class="text-caption">Monto Compensado: <b>{{
                                        formatCurrency(Math.min(selectedPayment.AmountML, debtTotals.ml), 'S/')
                                            }}</b></span>
                                    <v-chip x-small :color="getComparisonColor()"
                                        class="font-weight-bold text-uppercase white--text">
                                        {{ getComparisonText() }}
                                    </v-chip>
                                </div>
                            </div>
                        </v-col> -->
                    </v-row>

                    <!-- Content Layout: Bottom Section - Debt Details Table -->
                    <v-card class="elevation-0 border rounded-xl overflow-hidden bg-white">
                        <v-card-title class="px-4 py-2 grey lighten-4 d-flex align-center"
                            style="border-bottom: 1px solid #e4e4e7;">
                            <span class="text-subtitle-2 font-weight-bold grey--text text--darken-3">
                                Desglose de Deudas Pendientes de Compensación
                            </span>
                            <v-spacer></v-spacer>
                            <v-progress-circular indeterminate size="20" width="2" color="primary"
                                v-if="loadingDebtDetails"></v-progress-circular>
                        </v-card-title>

                        <v-data-table :headers="debtHeaders" :items="debtDetails" :items-per-page="5"
                            class="elevation-0" dense fixed-header height="260px"
                            no-data-text="No hay deudas registradas para este proveedor.">
                            <template v-slot:[`item.AccountingDate`]="{ item }">
                                <span class="text-caption font-weight-medium">
                                    {{ $fun.formatDateView(item.AccountingDate) }}
                                </span>
                            </template>

                            <template v-slot:[`item.DocumentType`]="{ item }">
                                <span class="doc-type-badge">
                                    {{ item.DocumentType }}
                                </span>
                            </template>

                            <template v-slot:[`item.Glosa`]="{ item }">
                                <div class="text-caption text-truncate grey--text text--darken-2"
                                    style="max-width: 320px;" :title="item.Glosa">
                                    {{ item.Glosa }}
                                </div>
                            </template>

                            <template v-slot:[`item.AmountME`]="{ item }">
                                <span class="font-weight-bold font-mono text-subtitle-2 red--text text--darken-2">
                                    {{ formatCurrency(Math.abs(item.AmountME), 'US$') }}
                                </span>
                            </template>

                            <template v-slot:[`item.AmountML`]="{ item }">
                                <span class="font-weight-bold font-mono text-subtitle-2 red--text text--darken-2">
                                    {{ formatCurrency(Math.abs(item.AmountML), 'S/') }}
                                </span>
                            </template>

                            <template v-slot:[`item.TypeDebt`]="{ item }">
                                <span :class="getTypeDebtClass(item.TypeDebt)">
                                    {{ item.TypeDebt }}
                                </span>
                            </template>
                        </v-data-table>
                    </v-card>

                    <!-- Content Layout: History Records Table (Anticipos / Insumos) -->
                    <!-- <v-card class="elevation-0 border rounded-xl overflow-hidden bg-white mt-4">
                        <v-card-title class="px-4 py-2.5 d-flex align-center bg-slate-50"
                            style="border-bottom: 1px solid #e2e8f0; background-color: #f8fafc;">
                            <div class="d-flex align-center">
                                <div class="header-icon-container mr-2 d-flex align-center justify-center rounded-lg"
                                    :class="isAdvanceType ? 'bg-amber-light' : 'bg-emerald-light'">
                                    <v-icon size="18" :color="isAdvanceType ? 'amber darken-3' : 'teal darken-2'">
                                        {{ isAdvanceType ? 'mdi-cash-fast' : 'mdi-package-variant-closed' }}
                                    </v-icon>
                                </div>
                                <div>
                                    <span class="text-subtitle-2 font-weight-bold text-slate-800 d-block"
                                        style="line-height: 1.2;">
                                        {{ isAdvanceType ? 'Histórico de Anticipos' : 'Histórico de Insumos' }}
                                    </span>
                                    <span class="text-caption text-slate-500">
                                        {{
                                            isAdvanceType
                                                ? 'Registro histórico de adelantos del productor'
                                                : 'Registro histórico de consumos del productor'
                                        }}
                                    </span>
                                </div>
                            </div>
                            <v-spacer></v-spacer>
                            <span :class="isAdvanceType ? 'type-debt-badge-magenta' : 'type-debt-badge-green'"
                                class="mr-3 font-mono font-weight-bold">
                                {{ isAdvanceType ? 'ANTICIPOS (PP)' : 'INSUMOS (CP)' }}
                            </span>
                            <v-progress-circular indeterminate size="18" width="2" color="primary"
                                v-if="loadingHistory"></v-progress-circular>
                        </v-card-title>

                        <v-data-table :headers="historyHeaders" :items="historyData" :items-per-page="15"
                            class="elevation-0 tailwind-styled-table" dense fixed-header height="280px"
                            no-data-text="No hay registros históricos para este proveedor.">

                            <template v-slot:[`item.AccountingDate`]="{ item }">
                                <span class="text-caption font-weight-medium font-mono text-slate-700">
                                    {{ $fun.formatDateView(item.AccountingDate) }}
                                </span>
                            </template>

                            <template v-slot:[`item.DueDate`]="{ item }">
                                <span class="text-caption font-mono text-slate-600">
                                    {{ $fun.formatDateView(item.DueDate) }}
                                </span>
                            </template>

                            <template v-slot:[`item.TaxDate`]="{ item }">
                                <span class="text-caption font-mono text-slate-600">
                                    {{ $fun.formatDateView(item.TaxDate) }}
                                </span>
                            </template>

                            <template v-slot:[`item.TypeDocumentName`]="{ item }">
                                <span class="doc-type-pill">
                                    {{ item.TypeDocumentName || '-' }}
                                </span>
                            </template>

                            <template v-slot:[`item.Glosa`]="{ item }">
                                <div class="text-caption text-truncate text-slate-600" style="max-width: 250px;"
                                    :title="item.Glosa">
                                    {{ item.Glosa || '-' }}
                                </div>
                            </template>

                            <template v-slot:[`item.CurrencyName`]="{ item }">
                                <v-chip x-small class="font-weight-bold font-mono px-2"
                                    :color="item.CurrencyName === 'US$' ? 'indigo' : 'teal'" outlined>
                                    {{ item.CurrencyName || '-' }}
                                </v-chip>
                            </template>

                            <template v-slot:[`item.DocRate`]="{ item }">
                                <span class="font-mono text-caption text-slate-600">
                                    {{
                                        (item.DocRate !== undefined && item.DocRate !== null)
                                            ? parseFloat(item.DocRate).toFixed(4) : '-'
                                    }}
                                </span>
                            </template>

                            <template v-slot:[`item.DebitCreditSC`]="{ item }">
                                <v-chip x-small class="font-weight-bold font-mono px-2"
                                    :color="(item.DebitCreditSC || item.debitCreditSC || '').toString().trim().toUpperCase() === 'C' ? 'green' : 'blue-grey'"
                                    outlined>
                                    {{ (item.DebitCreditSC || item.debitCreditSC || '-').toString().trim() }}
                                </v-chip>
                            </template>

                            <template v-slot:[`item.AmountML`]="{ item }">
                                <span class="font-weight-bold font-mono text-caption text-slate-800"
                                    :class="{ 'text-green': (item.DebitCreditSC || item.debitCreditSC || '').toString().trim().toUpperCase() === 'C' }">
                                    {{ formatCurrency(item.AmountML, 'S/') }}
                                </span>
                            </template>

                            <template v-slot:[`item.AmountME`]="{ item }">
                                <span class="font-weight-bold font-mono text-caption text-slate-800">
                                    {{ formatCurrency(item.AmountME, 'US$') }}
                                </span>
                            </template>

                            <template v-slot:[`item.AccumulatedBalanceML`]="{ item }">
                                <span class="font-mono text-caption text-slate-700">
                                    {{ formatCurrency(item.AccumulatedBalanceML, 'S/') }}
                                </span>
                            </template>

                            <template v-slot:[`item.AccumulatedBalanceME`]="{ item }">
                                <span class="font-mono text-caption text-slate-700">
                                    {{ formatCurrency(item.AccumulatedBalanceME, 'US$') }}
                                </span>
                            </template>

                            <template v-slot:[`item.AmountReconciled`]="{ item }">
                                <span class="font-mono text-caption text-slate-700">
                                    {{ formatCurrency(item.AmountReconciled, item.CurrencyName === 'US$' ? 'US$' : 'S/')
                                    }}
                                </span>
                            </template>

                            <template v-slot:[`item.AmountPending`]="{ item }">
                                <span class="font-weight-black font-mono text-caption"
                                    :class="parseFloat(item.AmountPending || 0) > 0 ? 'red--text text--darken-2' : 'green--text text--darken-3'">
                                    {{ formatCurrency(item.AmountPending, item.CurrencyName === 'US$' ? 'US$' : 'S/') }}
                                </span>
                            </template>
                        </v-data-table>
                    </v-card> -->
                </v-card-text>

                <v-card-actions class="px-4 py-3 grey lighten-5 justify-end" style="border-top: 1px solid #e4e4e7;">
                    <v-btn depressed color="error" class="text-none font-weight-medium rounded-lg px-4"
                        @click="debtAdjustmentModalVisible = false">
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import _TasProducerPaymentReportService from "@/services/Technicalassistance/TasProducerPaymentReport.js";
import _TasProducerDebtReportService from "@/services/Technicalassistance/TasProducerDebtReport.js";
import _TasProducerHistoryRecordService from "@/services/Technicalassistance/TasProducerHistoryRecord.js";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

export default {
    name: "TasProducerPaymentReport",
    data: () => ({
        filter: {
            TaxDate: null,
            Week: null
        },
        weeksList: [],
        loadingWeeks: false,
        config: {
            model: {
                DocNum: "ID",
                cardCode: "string",
                cardName: "string",
                transactionID: "string",
                accountingDate: "date",
                issueDate: "date",
                dueDate: "date",
                week: "number",
                yearWeek: "string",
                transactionType: "string",
                documentType: "string",
                typePayment: "string",
                docNum: "string",
                numAtCard: "string",
                currency: "string",
                amountML: "decimal",
                amountME: "decimal",
                amountMS: "decimal",
                accountCode: "string",
                accountName: "string",
                are: "string",
                glosa: "string",
                docStatus: "string",
                bankCode: "string",
                bankName: "string",
                accountNumber: "string",
                docType: "string",
                accountMain: "string",
                active: "string",
                Options: ""
            },
            service: _TasProducerPaymentReportService,
            headers: [
                { text: 'F. Contabilidad', value: 'AccountingDate', sortable: true, width: '100px' },
                { text: 'SEM', value: 'Week', align: 'center', sortable: true, width: '70px' },
                { text: 'Proveedor', value: 'CardCode', width: '220px', sortable: true, },
                // { text: 'Grupo', value: 'GroupName', sortable: true, },
                { text: 'Nº Fact. SAP', value: 'DocNum', align: 'center', sortable: true, width: '100px' },
                { text: 'Tipo Docum.', value: 'DocumentType', align: 'center', sortable: true, width: '110px' },
                { text: 'Estado SAP', value: 'DocStatus', align: 'center', sortable: true, width: '100px' },
                // { text: 'Art/Serv', value: 'DocType', sortable: true, width: '100px' },
                { text: 'Operación', value: 'TransactionID', align: 'center', sortable: true, width: '100px' },
                { text: 'F. Emisión', value: 'IssueDate', align: 'center', sortable: true, width: '100px' },
                { text: 'F. Venc.', value: 'DueDate', align: 'center', sortable: true, width: '100px' },
                // { text: 'Año Semana', value: 'YearWeek', sortable: true, width: '130px' },
                // { text: 'Tipo Transacción', value: 'TransactionType', sortable: true, width: '120px' },
                { text: 'Tipo Pago', value: 'TypePayment', sortable: true, width: '120px' },
                { text: 'N° Serie SUNAT', value: 'NumAtCard', sortable: true, width: '120px' },
                { text: 'Moneda Pago', value: 'Currency', align: 'center', sortable: true, width: '100px' },
                { text: 'TOTAL SISTEMA', value: 'AmountMS', sortable: true, width: '130px', align: 'center' },
                { text: 'TOTAL SOLES', value: 'AmountML', sortable: true, width: '130px', align: 'center' },
                { text: 'TOTAL DÓLARES', value: 'AmountME', sortable: true, width: '130px', align: 'center' },
                // { text: 'Código Cuenta', value: 'AccountCode', sortable: true, width: '120px' },
                // { text: 'Cuenta', value: 'AccountName', sortable: true, width: '200px' },
                // { text: 'Área Solicitante', value: 'Are', sortable: true, width: '160px' },
                { text: 'Glosa', value: 'Glosa', sortable: true, width: '160px' },
                // { text: 'Código Banco', value: 'BankCode', sortable: true, width: '120px' },
                { text: 'Nombre Banco', value: 'BankName', align: 'center', sortable: true, width: '180px' },
                // { text: 'Cuenta', value: 'AccountNumber', sortable: true, width: '150px' },
                // { text: 'Cuenta Mayor', value: 'AccountMain', sortable: true, width: '140px' },
                { text: 'Activos', value: 'Active', align: 'center', sortable: true, width: '90px' },
                { text: 'Opciones', value: 'Options', align: 'center', sortable: false, width: '100px' },
            ]
        },
        item: null,
        selected: [],
        loadingCalculate: false,
        loadingExportMain: false,
        selectedPayment: null,
        debtDetails: [],
        loadingDebtDetails: false,
        historyData: [],
        loadingHistory: false,
        isAdvanceType: false,
        debtAdjustmentModalVisible: false,
        debtHeaders: [
            { text: "Fecha", value: "AccountingDate", width: 100, align: 'center', sortable: false },
            { text: "Tipo Documento", value: "DocumentType", width: 120, align: 'center', sortable: false },
            { text: "Glosa / Concepto", value: "Glosa", sortable: false },
            { text: "Saldo (USD)", value: "AmountME", align: 'right', width: 100, sortable: false },
            { text: "Saldo (SOLES)", value: "AmountML", align: 'right', width: 100, sortable: false },
            { text: "Tipo Deuda", value: "TypeDebt", align: 'center', width: 100, sortable: false },
        ],
        historyHeaders: [
            { text: 'Fecha Conta.', value: 'AccountingDate', align: 'center', sortable: false },
            // { text: 'Fecha Venc.', value: 'DueDate', align: 'center', sortable: false },
            // { text: 'Fecha Documento', value: 'TaxDate', align: 'center', sortable: false },
            // { text: 'Código Cuenta', value: 'AccountCode', align: 'start', sortable: false },
            // { text: 'Nombre Cuenta', value: 'AccountName', align: 'start', sortable: false },
            // { text: 'Código Productor', value: 'CardCode', align: 'start', sortable: false },
            // { text: 'Nombre Productor', value: 'CardName', align: 'start', sortable: false },
            // { text: 'Transacción ID', value: 'TransactionID', align: 'center', sortable: false },
            // { text: 'Tipo Documento', value: 'TypeDocumentName', align: 'start', sortable: false },
            // { text: 'Doc. Origen', value: 'DocNumOrigin', align: 'center', sortable: false },
            // { text: 'Referencia 1', value: 'Reference1', align: 'start', sortable: false },
            // { text: 'Referencia 2', value: 'Reference2', align: 'start', sortable: false },
            { text: 'Glosa', value: 'Glosa', align: 'start', sortable: false },
            { text: 'Moneda', value: 'CurrencyName', align: 'center', sortable: false },
            { text: 'T.C', value: 'DocRate', align: 'right', sortable: false },
            { text: 'Debito/Credito', value: 'DebitCreditSC', align: 'center', sortable: false },
            { text: 'Monto ML', value: 'AmountML', align: 'right', sortable: false },
            { text: 'Monto ME', value: 'AmountME', align: 'right', sortable: false },
            { text: 'Saldo Acum. ML', value: 'AccumulatedBalanceML', align: 'right', sortable: false },
            { text: 'Saldo Acum. ME', value: 'AccumulatedBalanceME', align: 'right', sortable: false },
            { text: 'Monto Reconciliado', value: 'AmountReconciled', align: 'right', sortable: false },
            { text: 'Saldo Pendiente', value: 'AmountPending', align: 'right', sortable: false }
        ]
    }),
    created() {
        this.filter.TaxDate = this.$moment().format("YYYY-MM-DD");
        this.fetchWeeksFromData();
    },
    computed: {
        debtTotals() {
            let totalML = 0;
            let totalME = 0;
            if (this.debtDetails && this.debtDetails.length > 0) {
                this.debtDetails.forEach(item => {
                    totalML += Math.abs(parseFloat(item.AmountML || 0));
                    totalME += Math.abs(parseFloat(item.AmountME || 0));
                });
            }
            return { ml: totalML, me: totalME };
        },
        nettedTotals() {
            if (!this.selectedPayment) return { ml: 0, me: 0 };
            const paymentML = parseFloat(this.selectedPayment.AmountML || 0);
            const paymentME = parseFloat(this.selectedPayment.AmountME || 0);
            const debtML = this.debtTotals.ml;
            const debtME = this.debtTotals.me;
            return {
                ml: Math.max(0, paymentML - debtML),
                me: Math.max(0, paymentME - debtME)
            };
        }
    },
    methods: {
        async fetchWeeksFromData() {
            this.loadingWeeks = true;
            try {
                const params = {
                    filter: {},
                    draw: 1,
                    start: 0,
                    length: -1,
                    order: [{ dir: "asc", column: "" }],
                    searchText: ""
                };
                const response = await _TasProducerPaymentReportService.pagination(params, this.$fun.getUserID());
                if (response.status === 200 && response.data && response.data.data) {
                    const allData = response.data.data;
                    const uniqueMap = new Map();
                    allData.forEach(item => {
                        const weekVal = item.Week !== undefined ? item.Week : item.week;
                        const yearWeekVal = item.YearWeek !== undefined ? item.YearWeek : item.yearWeek;
                        if (weekVal != null && yearWeekVal) {
                            uniqueMap.set(yearWeekVal, weekVal);
                        }
                    });
                    const list = [];
                    uniqueMap.forEach((weekVal, yearWeekKey) => {
                        list.push({
                            YearWeek: yearWeekKey,
                            Week: weekVal
                        });
                    });
                    list.sort((a, b) => b.YearWeek.localeCompare(a.YearWeek));
                    this.weeksList = list;

                    // Set default current week
                    const currentWeek = this.$moment().week();
                    const currentYear = this.$moment().year();
                    const currentYearWeek = `${currentYear}-${String(currentWeek).padStart(2, '0')}`;
                    const foundCurrent = list.find(w => Number(w.Week) === currentWeek || w.YearWeek === currentYearWeek);
                    if (foundCurrent) {
                        // this.filter.Week = foundCurrent.Week;
                    }
                }
            } catch (error) {
                console.error("Error fetching weeks:", error);
            } finally {
                this.loadingWeeks = false;
            }
        },
        openDebtAdjustmentModal(item) {
            this.selectedPayment = item;
            this.debtDetails = [];
            this.historyData = [];
            this.loadingDebtDetails = true;
            this.loadingHistory = true;
            this.debtAdjustmentModalVisible = true;

            const params = {
                CardCode: item.CardCode.substring(1),
                TaxDate: this.filter.TaxDate || new Date().toISOString().split('T')[0]
            };

            _TasProducerDebtReportService.detail(params, this.$fun.getUserID()).then((result) => {
                if (result.status == 200) {
                    this.debtDetails = result.data || [];
                }
            }).catch((err) => {
                console.error("Error loading producer debt details:", err);
                this.$fun.alert("Error al cargar las deudas del productor.", "error");
            }).finally(() => {
                this.loadingDebtDetails = false;
            });

            this.fetchProducerHistory(item.CardCode);
        },
        async fetchProducerHistory(CardCode) {
            this.loadingHistory = true;
            this.historyData = [];
            try {
                this.isAdvanceType = CardCode.startsWith("PP");
                const params = {
                    filter: { CardCode },
                    draw: 1,
                    start: 0,
                    length: -1,
                    // order: [{ dir: "asc", column: "" }],
                    searchText: ""
                };
                console.log(JSON.parse(JSON.stringify({ params })))

                let response;
                if (this.isAdvanceType) {
                    response = await _TasProducerHistoryRecordService.paginationAdvanceMoney(params, this.$fun.getUserID());
                } else {
                    response = await _TasProducerHistoryRecordService.paginationAdvanceSupplies(params, this.$fun.getUserID());
                }

                if (response && response.status === 200 && response.data) {
                    if (Array.isArray(response.data.data)) {
                        this.historyData = response.data.data;
                    } else if (Array.isArray(response.data)) {
                        this.historyData = response.data;
                    }
                }
            } catch (error) {
                console.error("Error fetching producer history:", error);
                this.$fun.alert("Error al cargar el histórico del productor.", "error");
            } finally {
                this.loadingHistory = false;
            }
        },
        getTypeDebtClass(type) {
            if (!type) return 'type-debt-badge-gray';
            const t = type.toUpperCase();
            if (t.includes('ANTICIPO')) return 'type-debt-badge-magenta';
            if (t.includes('INSUMO')) return 'type-debt-badge-green';
            return 'type-debt-badge-gray';
        },
        getComparisonColor() {
            if (!this.selectedPayment) return 'grey';
            const paymentML = parseFloat(this.selectedPayment.AmountML || 0);
            const debtML = this.debtTotals.ml;
            if (debtML === 0) return 'success';
            if (debtML >= paymentML) return 'error';
            return 'warning';
        },
        getComparisonText() {
            if (!this.selectedPayment) return '';
            const paymentML = parseFloat(this.selectedPayment.AmountML || 0);
            const debtML = this.debtTotals.ml;
            if (debtML === 0) return 'Sin Deudas';
            if (debtML >= paymentML) return 'Total Compensado';
            return 'Ajuste Parcial';
        },
        rowSelected(item) {
            if (item && item.length > 0) {
                this.selected = item;
                this.item = { ...item[0] }
                console.log(JSON.parse(JSON.stringify(this.item)))
            } else {
                this.selected = [];
                this.item = null;
            }
        },
        formatCurrency(value, symbol = 'S/') {
            const displaySymbol = symbol || 'S/';
            if (value === null || value === undefined || value === "") return `${displaySymbol} 0.00`;
            const num = parseFloat(value);
            if (isNaN(num)) return `${displaySymbol} 0.00`;
            return `${displaySymbol} ` + num.toLocaleString('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        },
        formatNumber(num) {
            if (num === null || num === undefined || num === "") return "0.00";
            const parsed = parseFloat(num);
            if (isNaN(parsed)) return "0.00";

            const formatted = Math.abs(parsed).toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });

            return parsed < 0 ? `(${formatted})` : formatted;
        },

        async exportExcel() {
            if (!this.$refs.crudproducerpayment) return;
            try {
                this.loadingExportMain = true;
                this.$fun.alert("Obteniendo datos de pagos para exportación...", "info");

                const currentParams = this.$refs.crudproducerpayment.parametersPagination;
                const params = {
                    filter: this.filter,
                    draw: 1,
                    start: 0,
                    length: -1, // all records
                    order: currentParams.order || [{ dir: "asc", column: "" }],
                    searchText: currentParams.searchText || ""
                };

                const response = await _TasProducerPaymentReportService.pagination(params, this.$fun.getUserID());
                if (response.status !== 200 || !response.data || !response.data.data) {
                    this.$fun.alert("No se pudieron obtener los datos para la exportación.", "error");
                    return;
                }

                const data = response.data.data;
                console.log(JSON.parse(JSON.stringify(data)))
                if (data.length === 0) {
                    this.$fun.alert("No hay registros para exportar con los filtros actuales.", "warning");
                    return;
                }

                this.$fun.alert("Generando Excel de pagos...", "info");

                const workbook = new ExcelJS.Workbook();
                const sheetName = "Pagos de Productores";
                const worksheet = workbook.addWorksheet(sheetName, {
                    properties: { tabColor: { argb: "FF1F4E78" } }
                });

                // Column structures
                worksheet.columns = [
                    { header: "Código", key: "cardCode", width: 15 },
                    { header: "Nombre Productor", key: "cardName", width: 35 },
                    { header: "Operación", key: "transactionID", width: 15 },
                    { header: "Fecha Contabilización", key: "accountingDate", width: 20 },
                    { header: "Fecha Emisión", key: "issueDate", width: 20 },
                    { header: "Fecha Vencimiento", key: "dueDate", width: 20 },
                    { header: "Semana", key: "week", width: 10 },
                    { header: "Año Semana", key: "yearWeek", width: 15 },
                    { header: "Tipo Transacción", key: "transactionType", width: 20 },
                    { header: "Tipo Documento", key: "documentType", width: 20 },
                    { header: "Tipo Pago", key: "typePayment", width: 15 },
                    { header: "Número SAP", key: "docNum", width: 15 },
                    { header: "Número SUNAT", key: "numAtCard", width: 20 },
                    { header: "Moneda", key: "currency", width: 12 },
                    { header: "Importe ML", key: "amountML", width: 15 },
                    { header: "Importe ME", key: "amountME", width: 15 },
                    { header: "Importe MS", key: "amountMS", width: 15 },
                    { header: "Código Cuenta", key: "accountCode", width: 15 },
                    { header: "Cuenta", key: "accountName", width: 30 },
                    { header: "Área Solicitante", key: "are", width: 20 },
                    { header: "Glosa", key: "glosa", width: 40 },
                    { header: "Estado", key: "docStatus", width: 12 },
                    { header: "Código Banco", key: "bankCode", width: 15 },
                    { header: "Nombre Banco", key: "bankName", width: 20 },
                    { header: "Cuenta Banco", key: "accountNumber", width: 20 },
                    { header: "Art/Serv", key: "docType", width: 12 },
                    { header: "Cuenta Mayor", key: "accountMain", width: 15 },
                    { header: "Activo", key: "activeStr", width: 12 }
                ];

                // Format headers
                const headerRow = worksheet.getRow(1);
                headerRow.height = 28;
                headerRow.eachCell((cell) => {
                    cell.fill = {
                        type: "pattern",
                        pattern: "solid",
                        fgColor: { argb: "FF1F4E78" }
                    };
                    cell.font = {
                        name: "Calibri",
                        size: 10,
                        bold: true,
                        color: { argb: "FFFFFFFF" }
                    };
                    cell.alignment = {
                        vertical: "middle",
                        horizontal: "center",
                        wrapText: true
                    };
                    cell.border = {
                        top: { style: "thin", color: { argb: "FFD3D3D3" } },
                        left: { style: "thin", color: { argb: "FFD3D3D3" } },
                        bottom: { style: "thin", color: { argb: "FFD3D3D3" } },
                        right: { style: "thin", color: { argb: "FFD3D3D3" } }
                    };
                });

                // Add records
                data.forEach((rowItem) => {
                    // const valOr = (propPascal, propCamel) => rowItem[propPascal] !== undefined ? rowItem[propPascal] : rowItem[propCamel];

                    const rowData = {
                        cardCode: rowItem["CardCode"],
                        cardName: rowItem["CardName"],
                        transactionID: rowItem["TransactionID"],
                        accountingDate: rowItem["AccountingDate"] ? this.$moment(rowItem["AccountingDate"]).format("DD/MM/YYYY") : "",
                        issueDate: rowItem["IssueDate"] ? this.$moment(rowItem["IssueDate"]).format("DD/MM/YYYY") : "",
                        dueDate: rowItem["DueDate"] ? this.$moment(rowItem["DueDate"]).format("DD/MM/YYYY") : "",
                        week: rowItem["Week"],
                        yearWeek: rowItem["YearWeek"],
                        transactionType: rowItem["TransactionType"],
                        documentType: rowItem["DocumentType"],
                        typePayment: rowItem["TypePayment"],
                        docNum: rowItem["DocNum"],
                        numAtCard: rowItem["NumAtCard"],
                        currency: rowItem["Currency"],
                        amountML: rowItem["AmountML"] != null ? Number(rowItem["AmountML"]) : 0,
                        amountME: rowItem["AmountME"] != null ? Number(rowItem["AmountME"]) : 0,
                        amountMS: rowItem["AmountMS"] != null ? Number(rowItem["AmountMS"]) : 0,
                        accountCode: rowItem["AccountCode"],
                        accountName: rowItem["AccountName"],
                        are: rowItem["Are"],
                        glosa: rowItem["Glosa"],
                        docStatus: rowItem["DocStatus"],
                        bankCode: rowItem["BankCode"],
                        bankName: rowItem["BankName"],
                        accountNumber: rowItem["AccountNumber"],
                        docType: rowItem["DocType"],
                        accountMain: rowItem["AccountMain"],
                        activeStr: rowItem["Active"] ? "Activo" : "Inactivo"
                    };

                    const row = worksheet.addRow(rowData);
                    row.height = 20;

                    row.eachCell((cell, colIdx) => {
                        cell.font = { name: "Calibri", size: 9 };
                        cell.border = {
                            top: { style: "thin", color: { argb: "FFE0E0E0" } },
                            left: { style: "thin", color: { argb: "FFE0E0E0" } },
                            bottom: { style: "thin", color: { argb: "FFE0E0E0" } },
                            right: { style: "thin", color: { argb: "FFE0E0E0" } }
                        };

                        if ([1, 3, 4, 5, 6, 7, 8, 11, 12, 13, 14, 18, 22, 23, 25, 26, 27, 28].includes(colIdx)) {
                            cell.alignment = { vertical: "middle", horizontal: "center" };
                        } else if ([15, 16, 17].includes(colIdx)) {
                            cell.numFmt = "#,##0.00";
                            cell.alignment = { vertical: "middle", horizontal: "right" };
                        } else {
                            cell.alignment = { vertical: "middle", horizontal: "left" };
                        }
                    });
                });

                // Add total summary row
                const totalsRow = worksheet.addRow([]);
                totalsRow.height = 24;
                const labelCell = totalsRow.getCell(1);
                labelCell.value = "TOTAL GENERAL";
                labelCell.font = { name: "Calibri", size: 9, bold: true };
                labelCell.alignment = { vertical: "middle", horizontal: "left" };

                // Merge cells for the label from column 1 to 14
                worksheet.mergeCells(`A${totalsRow.number}:N${totalsRow.number}`);

                const colLetter = (idx) => {
                    let temp = idx;
                    let letter = "";
                    while (temp > 0) {
                        let modulo = (temp - 1) % 26;
                        letter = String.fromCharCode(65 + modulo) + letter;
                        temp = Math.floor((temp - modulo) / 26);
                    }
                    return letter;
                };

                for (let colIdx = 1; colIdx <= worksheet.columns.length; colIdx++) {
                    const cell = totalsRow.getCell(colIdx);
                    cell.border = {
                        top: { style: "thin", color: { argb: "FFB0B0B0" } },
                        left: { style: "thin", color: { argb: "FFB0B0B0" } },
                        bottom: { style: "double", color: { argb: "FF000000" } },
                        right: { style: "thin", color: { argb: "FFB0B0B0" } }
                    };

                    if ([15, 16, 17].includes(colIdx)) {
                        const letter = colLetter(colIdx);
                        const dataStart = 2;
                        const dataEnd = data.length + 1;
                        cell.value = { formula: `SUM(${letter}${dataStart}:${letter}${dataEnd})` };
                        cell.font = { name: "Calibri", size: 9, bold: true };
                        cell.numFmt = "#,##0.00";
                        cell.alignment = { vertical: "middle", horizontal: "right" };
                    }
                }

                // Auto filter and views
                worksheet.autoFilter = {
                    from: { row: 1, column: 1 },
                    to: { row: 1, column: worksheet.columns.length }
                };

                worksheet.views = [
                    {
                        state: "frozen",
                        ySplit: 1, // Freeze header row
                        zoomScale: 100,
                        showGridLines: true
                    }
                ];

                const buffer = await workbook.xlsx.writeBuffer();
                const filename = `Reporte_Pagos_Productores_${new Date().getTime()}.xlsx`;
                saveAs(new Blob([buffer]), filename);
                this.$fun.alert("Archivo Excel generado y descargado correctamente.", "success");
            } catch (error) {
                console.error("Error generating main Excel:", error);
                this.$fun.alert("Ocurrió un error al generar el reporte Excel.", "error");
            } finally {
                this.loadingExportMain = false;
            }
        }
    },
};
</script>

<style scoped>
.font-weight-semibold {
    font-weight: 600;
}

.card-code-badge {
    display: inline-block;
    padding: 4px !important;
    border-radius: 8px !important;
    font-size: 10px !important;
    font-weight: 600 !important;
    line-height: 1 !important;
    background-color: rgba(25, 118, 210, 0.08) !important;
    color: #1976d2 !important;
    border: 1px solid #1976d2 !important;
    text-align: center;
    width: fit-content;
}

.summary-box-premium {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 16px;
    padding: 12px;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
    transition: all 0.25s ease-in-out;
}

.summary-box-premium:hover {
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.08), 0 2px 4px -1px rgba(0, 0, 0, 0.05);
    border-color: #cbd5e1;
}

.summary-box-premium.original-payment {
    border-left: 4px solid #3b82f6;
}

.summary-box-premium.total-debt {
    border-left: 4px solid #ef4444;
}

.summary-box-premium.net-payment {
    border-left: 4px solid #10b981;
}

.box-icon-label {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.box-title {
    font-size: 10px;
    font-weight: 700;
    color: #64748b;
    letter-spacing: 0.5px;
}

.main-amount {
    font-size: 24px;
    font-weight: 800;
    line-height: 1.2;
    color: #1e293b;
}

.border-t {
    border-top: 1px solid #f1f5f9;
}

.doc-type-badge {
    display: inline-block;
    padding: 4px 8px !important;
    border-radius: 8px !important;
    font-size: 10px !important;
    font-weight: 600 !important;
    line-height: 1 !important;
    background-color: rgba(113, 113, 122, 0.08) !important;
    color: #52525b !important;
    border: 1px solid #d4d4d8 !important;
    text-align: center;
    width: fit-content;
    white-space: nowrap;
}

.type-debt-badge-magenta {
    display: inline-block;
    padding: 4px 8px !important;
    border-radius: 8px !important;
    font-size: 10px !important;
    font-weight: 600 !important;
    line-height: 1 !important;
    background-color: rgba(217, 70, 239, 0.08) !important;
    color: #a21caf !important;
    border: 1px solid #d946ef !important;
    text-align: center;
    width: fit-content;
    white-space: nowrap;
}

.type-debt-badge-green {
    display: inline-block;
    padding: 4px 8px !important;
    border-radius: 8px !important;
    font-size: 10px !important;
    font-weight: 600 !important;
    line-height: 1 !important;
    background-color: rgba(34, 197, 94, 0.08) !important;
    color: #16a34a !important;
    border: 1px solid #22c55e !important;
    text-align: center;
    width: fit-content;
    white-space: nowrap;
}

.type-debt-badge-gray {
    display: inline-block;
    padding: 4px 8px !important;
    border-radius: 8px !important;
    font-size: 10px !important;
    font-weight: 600 !important;
    line-height: 1 !important;
    background-color: rgba(113, 113, 122, 0.08) !important;
    color: #52525b !important;
    border: 1px solid #d4d4d8 !important;
    text-align: center;
    width: fit-content;
    white-space: nowrap;
}

.bg-slate-50 {
    background-color: #f8fafc !important;
}

.text-slate-800 {
    color: #1e293b !important;
}

.text-slate-700 {
    color: #334155 !important;
}

.text-slate-600 {
    color: #475569 !important;
}

.text-slate-500 {
    color: #64748b !important;
}

.header-icon-container {
    width: 28px;
    height: 28px;
    border-radius: 8px;
}

.bg-amber-light {
    background-color: #fef3c7 !important;
}

.bg-emerald-light {
    background-color: #d1fae5 !important;
}

.doc-type-pill {
    display: inline-block;
    padding: 2px 8px !important;
    border-radius: 6px !important;
    font-size: 11px !important;
    font-weight: 600 !important;
    background-color: #f1f5f9 !important;
    color: #475569 !important;
    border: 1px solid #e2e8f0 !important;
    white-space: nowrap;
}

.tailwind-styled-table ::v-deep table thead th {
    background-color: #f8fafc !important;
    color: #475569 !important;
    font-size: 11px !important;
    font-weight: 700 !important;
    text-transform: uppercase !important;
    letter-spacing: 0.05em !important;
    border-bottom: 1px solid #e2e8f0 !important;
}

.tailwind-styled-table ::v-deep table tbody tr {
    transition: background-color 0.15s ease-in-out;
}

.tailwind-styled-table ::v-deep table tbody tr:hover {
    background-color: #f1f5f9 !important;
}

.tailwind-styled-table ::v-deep table tbody td {
    border-bottom: 1px solid #f1f5f9 !important;
    font-size: 12px !important;
}

.text-green {
    color: #2e7d32 !important;
}
</style>
